import { z } from "zod";

/** Request accepted by the operator-facing inventory grant endpoint. */
export const inventoryGrantRequestSchema = z
  .object({
    playerId: z.string().uuid(),
    itemId: z.string().min(1).max(80),
    quantity: z.number().int().min(1).max(1_000_000).default(1),
    rarity: z.string().min(1).max(16).default("uncommon"),
    tier: z.number().int().min(1).max(4).optional(),
    enhancementLevel: z.number().int().min(0).max(15).optional(),
  })
  .strict();

export type InventoryGrantRequest = z.infer<typeof inventoryGrantRequestSchema>;
